
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M1.94 11.79C1.34 12.35 1 13.14 1 13.97V20C1 21.66 2.34 23 4 23H17.68C18.33 23 18.93 22.53 19 21.88C19.08 21.13 18.49 20.5 17.76 20.5H12.5C12.22 20.5 12 20.28 12 20C12 19.72 12.22 19.5 12.5 19.5H19.68C20.33 19.5 20.93 19.03 21 18.38C21.08 17.63 20.49 17 19.76 17H12.5C12.22 17 12 16.78 12 16.5C12 16.22 12.22 16 12.5 16H20.68C21.33 16 21.93 15.53 22 14.88C22.08 14.13 21.49 13.5 20.76 13.5H12.5C12.22 13.5 12 13.28 12 13C12 12.72 12.22 12.5 12.5 12.5H18.68C19.33 12.5 19.93 12.03 20 11.38C20.08 10.63 19.49 9.99996 18.76 9.99996H8.86L10.35 7.38996C10.44 7.22996 10.49 7.05996 10.49 6.85996C10.49 6.59996 10.4 6.35996 10.23 6.15996L9.81 5.70996C9.43 5.31996 8.8 5.29996 8.4 5.67996L1.94 11.79ZM18.5 7.99996C19.88 7.99996 21 6.87996 21 5.49996C21 4.24996 19.59 2.33996 18.89 1.45996C18.69 1.20996 18.32 1.20996 18.12 1.45996C17.41 2.33996 16 4.24996 16 5.49996C16 6.87996 17.12 7.99996 18.5 7.99996ZM13.5 8.99996C14.33 8.99996 15 8.32996 15 7.49996C15 6.93996 14.33 6.00996 13.89 5.45996C13.69 5.20996 13.31 5.20996 13.12 5.45996C12.67 6.00996 12 6.93996 12 7.49996C12 8.32996 12.67 8.99996 13.5 8.99996Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-wash`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconWash

    ```js
    <b-new-b-icon-wash />
    ```
</docs>


